<section class="bg-white p-5">
  <div class=" space-y-6">
    <div
      class="flex flex-col gap-4 border-b border-gray-300 pb-5 lg:flex-row lg:items-center lg:justify-between"
    >
      <h1 class="text-xl font-bold text-dc-navy">
        {{ "NOTIFICATIONS.TITLE" | translate }}
      </h1>

      <app-button
        type="button"
        classesName="btn-width-auto"
        [label]="'NOTIFICATIONS.SETTINGS' | translate"
        [classesName]="'btn-edge-cut'"
        (onBtnClick)="openSettings()"
      />
    </div>

    <div
      class="flex flex-col gap-4 border-b border-gray-300 pb-5 sm:flex-row sm:flex-wrap sm:items-center"
    >
      <label
        class="flex items-center gap-3 text-sm cursor-pointer text-dc-navy"
      >
        <input
          type="checkbox"
          class="h-6 w-6 border-gray-300 accent-dc-navy"
          [(ngModel)]="showUnreadOnly"
          (ngModelChange)="onShowUnreadOnlyChange()"
        />
        <span>{{ "NOTIFICATIONS.FILTER.FAV_ONLY" | translate }}</span>
      </label>

      <div class="w-full sm:ms-auto" style="flex: 0 0 0 20rem; max-width: 20rem;">
        <app-option-field
          label=""
          [placeholder]="'NOTIFICATIONS.FILTER.ALL_MEMBERSHIP' | translate"
          [control]="membershipFilterControl"
          [options]="serviceFilterOptions"
          [labelKey]="'Value'"
          [valueKey]="'Value'"
        >
        </app-option-field>
      </div>
    </div>

    @if (loading) {
      <div class="p-2">
        <p class="text-sm text-dc-black">
          {{ "LOADING" | translate }}
        </p>
      </div>
    } @else if (filtered.length < 1) {
      <div class="p-2">
        <p class="text-sm text-dc-black">
          {{ "BG_DASH.NO_NOTIFICATIONS" | translate }}
        </p>
      </div>
    }

    @if (!loading && filtered.length > 0) {
      <section class="space-y-6 pt-2">
        @for (n of paginatedNotifications; track n.id) {
          <article
            class="relative border border-dc-navy p-4 sm:p-6"
            [ngClass]="{
              'bg-blue-50': n.highlight,
              'bg-white': !n.highlight
            }"
          >
            <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-6">
              <div class="flex flex-1 items-center gap-4 min-w-0">
                <div
                  class="flex h-9 w-9 shrink-0 items-center justify-center bg-white self-center"
                >
                  <img
                    [src]="getIconSrc(n.icon)"
                    [alt]="n.icon"
                    class="h-6 w-6 object-contain"
                  />
                </div>

                <div class="min-w-0 space-y-1">
                  <h3
                    class="font-semibold text-lg text-dc-black"
                    [class.cursor-pointer]="!!n.srNumber"
                    (click)="n.srNumber ? viewDetail(n) : null"
                  >
                    {{ n.heading }}
                  </h3>
                  <p class="text-sm! text-dc-black!">
                    {{ n.body }}
                  </p>

                  <!-- @if (n.service) {
                    <p class="text-sm text-dc-black!">
                      {{ "MY_APPS.FILTER.SERVICE" | translate }} :
                      {{ n.service }}
                    </p>
                  } -->

                  @if (n.membershipName) {
                    <p class="text-sm! text-dc-black!">
                      {{ "NOTIFICATIONS.MEMBERSHIP" | translate }} :
                      {{ n.membershipName }}
                    </p>
                  }

                  <p class="text-sm! text-dc-black-light!">
                    {{ getTimeAgo(n.createdOnDate, n.created) }}
                  </p>
                </div>
              </div>

              <div
                class="flex flex-col items-start gap-3 self-center lg:min-w-[13rem] lg:items-end"
              >
                @if (n.downloadUrl) {
                  <app-button
                    type="button"
                    [classesName]="'card-edge-cut-white btn-width-auto text-dc-navy'"
                    [label]="'NOTIFICATIONS.ACTION.DOWNLOAD_CERT' | translate"
                    (onBtnClick)="openDownload(n.downloadUrl)"
                  />
                  <div class="flex items-center gap-3 self-end">
                    <a
                      class="cursor-pointer text-sm font-medium text-dc-navy underline underline-offset-2"
                      (click)="viewDetail(n)"
                    >
                      {{ "NOTIFICATIONS.ACTION.SEE_DETAIL" | translate }}
                    </a>

                    <button
                      class="inline-flex h-6 w-6 items-center justify-center bg-transparent p-0"
                      (click)="remove(n.id)"
                      aria-label="Dismiss"
                      type="button"
                    >
                      <img src="/icons/svg/close.svg" alt="" class="h-4 w-4" />
                    </button>
                  </div>
                } @else if (shouldShowCompleteApplication(n)) {
                  <div class="flex items-center gap-3 self-end">
                    <app-button
                      type="button"
                      [classesName]="'card-edge-cut-white btn-width-auto text-dc-navy'"
                      [label]="'NOTIFICATIONS.ACTION.COMPLETE_APP' | translate"
                      (onBtnClick)="viewDetail(n)"
                    />

                    <button
                      class="inline-flex h-6 w-6 items-center justify-center bg-transparent p-0"
                      (click)="remove(n.id)"
                      aria-label="Dismiss"
                      type="button"
                    >
                      <img src="/icons/svg/close.svg" alt="" class="h-4 w-4" />
                    </button>
                  </div>
                } 
                <!-- @else if (shouldShowPay(n)) {
                  <div class="flex items-center gap-3 self-end">
                    <app-button
                      type="button"
                      [classesName]="'btn-edge-cut-white min-w-[9rem]'"
                      [label]="'BUTTONS.PAY' | translate"
                      (onBtnClick)="goToPayment(n)"
                    />

                    <button
                      class="inline-flex h-6 w-6 items-center justify-center bg-transparent p-0"
                      (click)="remove(n.id)"
                      aria-label="Dismiss"
                      type="button"
                    >
                      <img src="/icons/svg/close.svg" alt="" class="h-4 w-4" />
                    </button>
                  </div>
                }  -->
                @else {
                  <div class="flex items-center gap-3 self-end">
                    @if (n.srNumber) {
                      <a
                        class="cursor-pointer text-sm font-medium text-dc-navy underline underline-offset-2"
                        (click)="viewDetail(n)"
                      >
                        {{ "NOTIFICATIONS.ACTION.SEE_DETAIL" | translate }}
                      </a>
                    }

                    <button
                      class="inline-flex h-6 w-6 items-center justify-center bg-transparent p-0"
                      (click)="remove(n.id)"
                      aria-label="Dismiss"
                      type="button"
                    >
                      <img src="/icons/svg/close.svg" alt="" class="h-4 w-4" />
                    </button>
                  </div>
                }
              </div>
            </div>
          </article>
        }

        @if (totalPages > 1) {
          <app-table-pagenation
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            (prev)="prevPage()"
            (next)="nextPage()"
            (goToPage)="goToPage($event)"
          />
        }
      </section>
    }
  </div>
</section>
